import firebase from "../firebase";

const leads = firebase.ref("/leads");
const partners = firebase.ref("/partners");
import UtilService from "@/services/UtilService";

class LeadService {
  getAll(userInfo) {
    if(userInfo.Role === 'Partner Admin' || userInfo.Role === 'Partner Staff'){
      return leads.orderByChild("Partner").equalTo(userInfo['PartnerId']);
    } else {
      return leads.orderByChild("IsDeleted").equalTo(0);
    }
  }
  
  getById(Id) {
    var ref = leads.child('/'+Id);
    return ref;
  }

  create(lead) {
    return leads.orderByChild("CompanyName").equalTo(lead["CompanyName"]).once("value", snapshot => {
        if (snapshot.exists()){
          return null;
        } else {
            const userInfo = JSON.parse(localStorage.getItem("userInfo"));
            var newPostRef = leads.push();
            var Id = newPostRef.key;
            lead['Id'] = Id;
            
            lead['Partner'] = lead['Partner'] ? lead['Partner'] : "-MLwfof_b8MpqAFeT4Uf" //dev
            lead['Code'] = lead['Code'] ? lead['Code'] : "-MNYZQeuiYUv7QaGNert" //dev

            // lead['Partner'] = lead['Partner'] ? lead['Partner'] : "-MRPV8Q4TqaP5Ef0YrKK" //prod
            // lead['Code'] = lead['Code'] ? lead['Code'] : "-MRPV8QDFjvFkd6Xxzvk"//prod

            lead["CreatedDate"] = lead["ModifiedDate"] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);
            return leads.child(Id).set(lead);
        }
    });
  }

  update(key, lead) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    lead["ModifiedDate"] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);
    return leads.child(key).update(lead);
  }

  convert(key){
    leads.orderByChild("CompanyName")
    return leads.child(key).update({ 
      IsConverted: 1
     });
  }

  delete(key) {
    return leads.child(key).update({ 
      IsDeleted: 1
     });
  }

  deleteAll() {
    return leads.remove();
  }


  getPartnerVal(){
    return partners
  }

  getPartnerById(id){
    return partners.orderByChild("Id").equalTo(id);
  }
  
}

export default new LeadService();
